var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:'p-loadingAnimation__nonBg' + _vm.modefire},[_c('div',{staticClass:"p-loadingAnimation__cubeWrap--nonBg"},_vm._l((9),function(index){return _c('div',{key:index,class:'p-loadingAnimation__nonBgCubeUnit' + index})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }